import React, { useState } from "react";
import "../pages/styles/home.css";
import "../pages/styles/mediaqueries.css";
import logo from "../Assets/images/Logo_Square_mini.png";
import steamLogo from "../Assets/images/steam-logo.png";
import activeicon from "../Assets/images/GNB_Active_line.png";
import { NavLink } from "react-router-dom";

const Header = () => {
  const [pathName, setPathName] = useState(window.location.pathname || "/");
  const hideNavBar = () => {
    const navbarScroll = document.querySelector("#navbarScroll");
    navbarScroll.classList.toggle("show");
  };
  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary px-lg-5">
      <div className="container-fluid">
        <NavLink
          onClick={() => setPathName("/")}
          className="navbar-brand"
          to="/"
        >
          <img src={logo} alt="logo" />
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarScroll"
          aria-controls="navbarScroll"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarScroll">
          <ul
            className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll"
            // style="--bs-scroll-height: 100px"
          >
            <li className="nav-item">
              <NavLink onClick={hideNavBar} className={`nav-link`} to={"/"}>
                About
                <img src={activeicon} alt="" />
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink onClick={hideNavBar} className={`nav-link`} to={"/team"}>
                Team
                <img src={activeicon} alt="" />
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                onClick={hideNavBar}
                className={`nav-link`}
                to={"/gameplay"}
              >
                Gameplay
                <img src={activeicon} alt="" />
              </NavLink>
            </li>

            {/* <li className="nav-item">
              <NavLink
                onClick={hideNavBar}
                className={`nav-link`}
                to={"/media"}
              >
                Media
              </NavLink>
            </li> */}

            <li className="nav-item">
              <NavLink
                onClick={hideNavBar}
                className={({ isActive }) =>
                  `nav-link ${
                    isActive || window.location.pathname.startsWith("/hero")
                      ? "active"
                      : ""
                  }`
                }
                to={"/heroes"}
              >
                Heroes
                <img src={activeicon} alt="" />
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                onClick={hideNavBar}
                className={({ isActive }) =>
                  `nav-link ${
                    isActive || window.location.pathname.startsWith("/items")
                      ? "active"
                      : ""
                  }`
                }
                to={"/items"}
              >
                Items
                <img src={activeicon} alt="" />
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                onClick={hideNavBar}
                className={({ isActive }) =>
                  `nav-link ${
                    isActive || window.location.pathname.startsWith("/monsters")
                      ? "active"
                      : ""
                  }`
                }
                to={"/monsters"}
              >
                Monsters
                <img src={activeicon} alt="" />
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                onClick={hideNavBar}
                className={`nav-link`}
                to={"/changelog"}
              >
                Changelog
                <img src={activeicon} alt="" />
              </NavLink>
            </li>
            {/* <li className="nav-item d-lg-none">
              <NavLink
                onClick={hideNavBar}
                className={`nav-link`}
                to={"/contact"}
              >
                Contact Us
              </NavLink>
            </li> */}
            <li className="contact_us_btn_container">
              <button className="d-none d-lg-block" type="submit">
                {/* <NavLink
                  onClick={() => setPathName("/contact")}
                  to={"/contact"}
                > */}
                <a
                  href="https://store.steampowered.com/app/2783670/Roshpit_Champions_2/"
                  target="_blank"
                >
                  {" "}
                  JOIN ON
                  <img src={steamLogo} />
                </a>

                {/* </NavLink> */}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
